// extracted by mini-css-extract-plugin
module.exports = {"textHeader":"_1y2V-nOS3aqxHqc3xqGKx9"};